import { useEffect, useState } from "react";
import Icon from '../atoms/Icon';
import { makeBEM } from "../global/utils";
import ToggleSetting from "./ToggleSetting";

function GeneralSetting(props) {
    const moduleName = 'setting';
    const [data, setData] = useState([]);

    const switchViewBtnClass = `btn btn--icon btn--no-border btn--setting ${makeBEM(moduleName, 'switch-view-btn')}`;

    useEffect(() => {
        if ( props.data ) {
            setData(props.data);
        } 
    }, [props]);

    const handleSwitchChange = (e) => {
        /* TODO: Implement switch change functionality */
    }

    const handleSwitchViewBtn = (e) => {
        if ( props.switchViewAction ) {
            props.switchViewAction();
        }
    }

    return (
        <div className="setting">
            <div className="setting__title-and-edit">
                { 
                    <button className={switchViewBtnClass} onClick={handleSwitchViewBtn} >
                        <Icon name="chevron-left" />
                    </button>
                }
                <h3 className="h3 setting__title">{data.title}</h3>
            </div>
            <div className="setting__column-names">
                <span className="label">Title</span>
                <span className="label">On</span>
            </div>
            <div className="contents__wrapper">
                <ul className="settings__list">
                    <li className="settings__list-item">
                        <ToggleSetting title="Dark Mode Always" onChange={handleSwitchChange}/>
                    </li>
                    
                    <li className="settings__list-item">
                        <ToggleSetting title="Vaporwave Dark Mode" onChange={handleSwitchChange}/>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default GeneralSetting;